import {styled} from "@reside/ui";

export const DisableClick = styled.div`
  pointer-events: none;
  &:hover {
    cursor: move;
  }
`;
